import { partnersMap } from '@/utils/partnership';
import { useFields } from './useFields';

export const usePartnership = () => {
  const fields = useFields();
  const partnership = `${fields?.partnership}`;
  return partnersMap.get(partnership);
};
